<template >
    <div id="billingAddress">
        <div v-show="shippingAddress">

            <div id="billingAddressSame">
                <input id="isSameAddress" v-model="isSameAddress" type="checkbox">
                <label for="isSameAddress">Utiliser la même adresse comme adresse de facturation</label>
            </div>

            <div v-if="address && !isSameAddress">
                <span class="btn btn-secondary edit-address btnEdit" @click="edit" style="top: 30px;">Modifier mon adresse</span>

                <span class="headerTitle">Adresse de facturation</span>
                <div id="billingAddressSelected">
                    <ul>
                        <li id="billingAddressTitle">{{ address.title }}</li>
                        <li id="billingAddressNames">{{ address.firstname }} {{ address.lastname }}</li>
                        <li id="billingAddressAddress">{{ address.number }} {{ address.address1 }}</li>
                        <li id="billingAddressCountry">{{ address.zipcode }} {{ address.country.name }}</li>
                        <li id="billingAddressPhone">
                            <i class="fa fa-phone"></i>
                            {{ address.phone }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="mt-4" v-show="!isSameAddress && !address && !isLoading">
                <form id="billingAddressForm" name="billingAddress" method="post" novalidate="novalidate" autocomplete="off" v-on:submit.prevent="billingAddressSubmit">
                    <slot name="billingAddressForm"/>

                    <div class="text-center">
                        <button id="billingAddressSubmit" type="submit" class="btn btn-primary">Valider</button>
                    </div>
                </form>
            </div>

            <ponroy-order-addresses-modal id="billingAddressesBookModal" form-name="billingAddressModal" slot-name="billingAddressModalForm" type="billing">
                <slot slot="billingAddressModalForm" name="billingAddressModalForm"></slot>
            </ponroy-order-addresses-modal>
        </div>

    </div>
</template>

<script>

    import store from '../../store';
    import {mapState, mapActions, mapGetters} from 'vuex';


    const OrderBillingAddress = {
        name: 'ponroy-order-billing-address',
        store,
        props: {
            address : {
                type: Object,
                required: false,
            },
        },
        computed: {
            ...mapGetters('order', [
                'addresses',
                'shippingAddress',
                'billingAddressErrors',
                'isLoading',
            ]),
            isSameAddress: {
                get () { return this.$store.state.order.isSameAddress; },
                set (value) { this.$store.commit('order/SET_IS_SAME_ADDRESS', value) }
            }
        },
        methods: {
            ...mapActions('order', [
                'addBillingAddress',
            ]),
            billingAddressSubmit(event) {
                event.preventDefault();
                let formData = this.serialize(event.target);
                this.addBillingAddress(formData);
            },

            serialize(form) {
                let $form = $(form), data = '';
                $form.find('input, select').each(function() {
                    if($(this).attr('type') == 'radio' && !$(this).prop('checked')) { return; }
                    data += $(this).attr('name');
                    data += '=';
                    data += $(this).val();
                    data += '&';
                });

                return data;
            },

            edit() {
                $('#billingAddressesBookModal').modal({show: true});
            },

        },
        watch: {
            isSameAddress(value) {
                if (true === value) {
                    this.$store.commit('order/SET_BILLING_ADDRESS_ERRORS', {});
                }
            },
            billingAddressErrors(value) {
                $('.invalid-feedback').remove();
                $('form#billingAddressForm :input').removeClass('is-invalid');

                if (0 < Object.keys(value).length) {
                    $.each(value, function (k, v) {
                        let $input = $("#billingAddress_" + k);
                        $input.addClass("is-invalid");
                        $input.parent().append('<div class="invalid-feedback"><span class="error">' + v + '</span></div>');
                    });
                }
            }
        }
    };

    export default OrderBillingAddress;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderBillingAddress.vue